module.exports = __webpack_public_path__ + "src/img/artist/artistpage1_1.svg?0cc296adbc4ac8116f0704e8b7cd97ef";


//////////////////
// WEBPACK FOOTER
// ./src/img/artist/artistpage1_1.svg
// module id = 118
// module chunks = 0